export const PROJECTILE_DIRECTIONS = [
  "north",
  "north_east",
  "east",
  "south_east",
  "south",
  "south_west",
  "west",
  "north_west",
] as const;

export type ProjectileDirection = (typeof PROJECTILE_DIRECTIONS)[number];

const DIRECTION_SECTORS = [
  "east",
  "south_east",
  "south",
  "south_west",
  "west",
  "north_west",
  "north",
  "north_east",
] as const satisfies readonly ProjectileDirection[];

/** Quantizes a screen-space vector (positive Y points south) to eight ways. */
export function projectileDirectionFromVector(
  dx: number,
  dy: number,
): ProjectileDirection | undefined {
  if (!Number.isFinite(dx) || !Number.isFinite(dy) || Math.hypot(dx, dy) < 1e-6)
    return undefined;

  const radians = (Math.atan2(dy, dx) + Math.PI * 2) % (Math.PI * 2);
  const sector = Math.round(radians / (Math.PI / 4)) % DIRECTION_SECTORS.length;
  return DIRECTION_SECTORS[sector];
}
